import { render, staticRenderFns } from "./status-info.vue?vue&type=template&id=31618492&"
import script from "./status-info.vue?vue&type=script&lang=tsx&"
export * from "./status-info.vue?vue&type=script&lang=tsx&"
import style0 from "./status-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports